import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-fg small text-center text-white-50">
      <div className="container">
        Copyright &copy; <a rel="noreferrer" href="https://www.chinasystems.com" target="_blank"> China Systems </a> - Trade Digitalisation Services
      </div>
      <a rel="noreferrer" href="https://www.chinasystems.com/footer/privacy" target="_blank">Cookies - Privacy Policy - Terms</a> 
    </footer>
  );
}
